var _defs, _g, _circle, _path, _path2, _rect, _rect2, _rect3, _path3, _path4, _path5, _path6, _g2, _g3, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _text, _path59, _g4, _path60, _circle2, _path61, _ellipse, _path62, _path63, _rect4, _g5, _g6, _path64, _path65, _circle3, _circle4, _circle5, _circle6, _g7, _path66, _g8, _path67, _rect5, _g9, _path68, _g10, _path69, _path70, _path71, _path72, _g11, _g12, _g13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Grupo_2886",
    "data-name": "Grupo 2886",
    width: 600,
    height: 400,
    viewBox: "0 0 600 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xE1ngulo_2361",
    "data-name": "Rect\xE1ngulo 2361",
    width: 600,
    height: 400,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.884,
    y1: 1.467,
    x2: 0.884,
    y2: 0.425,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dbccff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1bbff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.911,
    y1: 1.471,
    x2: 0.911,
    y2: 0.429,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b5a6e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7760bf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1.554,
    y1: 2.065,
    x2: 1.554,
    y2: 1.022,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 2.871,
    y1: 8.262,
    x2: 1.767,
    y2: 8.262,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8b8be0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a177b7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1.502,
    y1: 3.63,
    x2: 1.502,
    y2: 3.112,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a177b7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1.914,
    y1: 2.071,
    x2: 1.914,
    y2: 0.99,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6456c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f2c95"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientTransform: "matrix(0, -1, -1, 0, 0.905, 1.121)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4b474b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.5,
    cy: 0.5,
    r: 0.194,
    gradientTransform: "matrix(2.584, 0, 0, -2.584, -2.116, 1.487)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9e8cef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#caafee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -1.06,
    y1: 0.5,
    x2: -2.06,
    y2: 0.5,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ccf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#755cbb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d5cdf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f3edfb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9e8cef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dac7f3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a999f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dac7f3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#ffc2a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9595"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffeadb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#c27cb6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#d1a1d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#bd89c4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb0b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984,
    stopColor: "#ffc2a9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ccedff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#755cbb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8642a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6456c0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 0.53,
    y1: 0.933,
    x2: 0.483,
    y2: 0.115,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1616a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8883"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cf6074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f37270"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cf6074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff817f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2e33a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0665a5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffeadb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#8860c7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ccc2db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#8860c7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#776d7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9d68c2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f77d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0686c9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 0.195,
    y1: 0.799,
    x2: 1.137,
    y2: 0.078,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffeadb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#b060f4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 0.039,
    y1: 0.812,
    x2: 1.003,
    y2: 0.231,
    xlinkHref: "#linear-gradient-64"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9d68c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aec2ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ccedff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9d68c2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d93de3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff6dba"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a242ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe117e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 0.566,
    y1: 1.055,
    x2: 0.452,
    y2: -0.06,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#067eff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e37a0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#459fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a96dff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b31a8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe117e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#linear-gradient-44"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d906e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff6df9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: -0.199,
    y1: -0.008,
    x2: -0.032,
    y2: -1.022,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1852a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#067ed3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: -0.043,
    y1: 0.058,
    x2: -0.043,
    y2: -0.917,
    xlinkHref: "#linear-gradient-85"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 0.952,
    y1: 0.316,
    x2: 1.06,
    y2: -0.334,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#188dc1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06bfe7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 0.647,
    y1: 1.113,
    x2: 0.39,
    y2: -0.137,
    xlinkHref: "#linear-gradient-87"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 1.938,
    y1: 0.969,
    x2: -1.115,
    y2: 0.036,
    xlinkHref: "#linear-gradient-85"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: -0.532,
    y1: 1.113,
    x2: -0.789,
    y2: -0.137,
    xlinkHref: "#linear-gradient-87"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: -0.952,
    y1: 0.969,
    x2: -4.006,
    y2: 0.036,
    xlinkHref: "#linear-gradient-85"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2885",
    "data-name": "Grupo 2885",
    clipPath: "url(#clip-path)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2843",
    "data-name": "Grupo 2843",
    transform: "translate(390.818 195.738)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5288",
    "data-name": "Trazado 5288",
    d: "M163.863,205.191c-.008-.245-.126-.365-.355-.358l-6.708.2a5.034,5.034,0,0,0-1.688.3,2.821,2.821,0,0,0-1.109.747,2.773,2.773,0,0,0-.592,1.137,5.12,5.12,0,0,0-.152,1.474l.056,1.842a5.146,5.146,0,0,0,.241,1.462,2.756,2.756,0,0,0,.66,1.1,2.841,2.841,0,0,0,1.153.678,5.02,5.02,0,0,0,1.7.2l3.612-.11.748-2.112.1,0,.064,2.088,2.531-.077Zm-2.341,6.33-4.288.13a1.389,1.389,0,0,1-1.042-.288,1.625,1.625,0,0,1-.34-1.121l-.046-1.5a1.59,1.59,0,0,1,.272-1.145,1.442,1.442,0,0,1,1.023-.332l4.1-.125a.169.169,0,0,1,.136.051.182.182,0,0,1,.053.127Z",
    transform: "translate(-102.892 -204.833)",
    fill: "#f1f1f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5289",
    "data-name": "Trazado 5289",
    d: "M172.806,209.029l.086,0,.081,2.678a.151.151,0,0,1-.166.177l-7.543.229.07,2.322,9.89-.3a.32.32,0,0,0,.345-.379l-.249-8.208a.32.32,0,0,0-.368-.357l-9.606.292a.326.326,0,0,0-.358.379l.071,2.323,2.373.8.1,0-.037-1.191c0-.09.037-.137.119-.139l5.073-.154a.136.136,0,0,1,.131.051.247.247,0,0,1,.034.116l.034,1.118-4.177.126.055,1.82,3.5-.107Z",
    transform: "translate(-126.07 -204.833)",
    fill: "#f1f1f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5290",
    "data-name": "Trazado 5290",
    d: "M178.659,208.862l.1,0-.029-.983a.13.13,0,0,1,.142-.152l4.718-.143a.379.379,0,0,1,.468.416l.007.221c.005.172-.019.283-.076.334a.68.68,0,0,1-.329.121l-5.528.942a3.708,3.708,0,0,0-.891.255,1.7,1.7,0,0,0-.59.424,1.437,1.437,0,0,0-.312.631,3.371,3.371,0,0,0-.073.875l.022.712a3.191,3.191,0,0,0,.165.972,1.645,1.645,0,0,0,.464.7,1.955,1.955,0,0,0,.824.411,4.475,4.475,0,0,0,1.245.11l7.96-.242-.07-2.321-7.137.216a.574.574,0,0,1-.428-.1.619.619,0,0,1-.116-.408l-.007-.245a.507.507,0,0,1,.069-.329.486.486,0,0,1,.31-.126l5.336-.838a4.3,4.3,0,0,0,.921-.25,1.775,1.775,0,0,0,.621-.412,1.425,1.425,0,0,0,.337-.613,2.86,2.86,0,0,0,.084-.851l-.019-.626a2.078,2.078,0,0,0-.56-1.49,2.329,2.329,0,0,0-1.737-.482l-7.948.242a.342.342,0,0,0-.369.4l.056,1.843Z",
    transform: "translate(-148.688 -204.833)",
    fill: "#f1f1f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5291",
    "data-name": "Trazado 5291",
    d: "M190.678,214.816l-.271-8.942-2.531.076.271,8.944Z",
    transform: "translate(-164.067 -204.833)",
    fill: "#f1f1f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5292",
    "data-name": "Trazado 5292",
    d: "M194.145,211.342c0-.131,0-.268.006-.412s.018-.269.032-.376l0-.111-2.506.077.133,4.385c.007.23.113.341.317.335l6.732-.2a5.031,5.031,0,0,0,1.688-.3,2.8,2.8,0,0,0,1.108-.747,2.753,2.753,0,0,0,.593-1.136,5.159,5.159,0,0,0,.152-1.474l-.056-1.843a5.153,5.153,0,0,0-.241-1.463,2.657,2.657,0,0,0-1.813-1.776,5.028,5.028,0,0,0-1.7-.2l-6.694.2a.321.321,0,0,0-.346.379l.059,1.93,2.373.789.1,0-.026-.86c0-.082.032-.124.106-.126l4.275-.13a2.5,2.5,0,0,1,.622.049.881.881,0,0,1,.42.221.989.989,0,0,1,.246.435,2.715,2.715,0,0,1,.1.68l.046,1.572a1.625,1.625,0,0,1-.272,1.14,1.392,1.392,0,0,1-1.023.351l-4.239.129c-.09,0-.135-.045-.138-.144Z",
    transform: "translate(-179.456 -204.833)",
    fill: "#f1f1f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5293",
    "data-name": "Trazado 5293",
    d: "M210.112,206.464a.7.7,0,0,0-.4.1.792.792,0,0,0-.206.276l-3.2,6.528a.258.258,0,0,1-.228.155l-.135,0a.174.174,0,0,1-.2-.191l-.2-6.732-2.3.07.261,8.588q.011.355.354.344l3.638-.11a.789.789,0,0,0,.383-.085.673.673,0,0,0,.232-.29l3.319-6.519a.245.245,0,0,1,.228-.155l.123,0a.174.174,0,0,1,.2.191l.2,6.721,2.3-.071-.26-8.575c-.008-.245-.125-.365-.355-.357Z",
    transform: "translate(-203.245 -204.833)",
    fill: "#f1f1f4"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1019",
    "data-name": "Elipse 1019",
    cx: 155.018,
    cy: 155.018,
    r: 155.018,
    transform: "translate(330.95 414.759) rotate(-135)",
    fill: "#e0f3ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2845",
    "data-name": "Grupo 2845",
    transform: "translate(425.805 176.345)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5294",
    "data-name": "Trazado 5294",
    d: "M153.773,194.7a23.8,23.8,0,0,1,10.553-9.264l2.351,1.1-5.294,9.605a10.3,10.3,0,0,0,3.239,5.72l.007-.016a10.3,10.3,0,0,0,6.466-1.186l3.97-10.223,2.35,1.1a23.8,23.8,0,0,1-.333,14.039s-1,2.314-1.176,2.516c-.931,1.087-3.36,2.342-8.055,2.051l-16.205,30.912a8.474,8.474,0,1,1-8.759-4.091l13.306-32.248c-3.167-3.342-3.836-5.975-3.6-7.495C152.648,196.9,153.773,194.7,153.773,194.7Zm-13.328,53.31,4.293,2,3.882-2.713-.41-4.719-4.292-2.005-3.883,2.713Z",
    transform: "translate(-134.675 -185.44)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5295",
    "data-name": "Trazado 5295",
    d: "M154.948,197.22a23.8,23.8,0,0,1,10.554-9.264l2.35,1.1-5.293,9.6a10.3,10.3,0,0,0,3.239,5.72l.007-.016a10.3,10.3,0,0,0,6.465-1.186l3.97-10.223,2.351,1.1a23.8,23.8,0,0,1-.334,14.038s-3.664,4.912-9.231,4.568l-16.2,30.912a8.474,8.474,0,1,1-8.759-4.092l13.3-32.248C153.532,203.182,154.948,197.22,154.948,197.22Zm-13.327,53.31,4.292,2.005,3.883-2.713-.41-4.719-4.293-2-3.882,2.713Z",
    transform: "translate(-137.026 -185.44)",
    fill: "url(#linear-gradient-2)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xE1ngulo_2313",
    "data-name": "Rect\xE1ngulo 2313",
    width: 2.594,
    height: 2.777,
    transform: "translate(41.565 8.613) rotate(-154.957)",
    fill: "#e5e2ff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xE1ngulo_2314",
    "data-name": "Rect\xE1ngulo 2314",
    width: 2.594,
    height: 2.777,
    transform: "matrix(-0.906, -0.423, 0.423, -0.906, 30.826, 3.614)",
    fill: "#e5e2ff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xE1ngulo_2315",
    "data-name": "Rect\xE1ngulo 2315",
    width: 4.738,
    height: 2.777,
    transform: "translate(8.887 67.095) rotate(-154.958)",
    fill: "#e5e2ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2844",
    "data-name": "Grupo 2844",
    transform: "translate(10.161 25.879)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5296",
    "data-name": "Trazado 5296",
    d: "M169.339,214.955l-13.087,25.151a6.4,6.4,0,0,1-5.283-2.469l10.653-26.287A10.05,10.05,0,0,1,169.339,214.955Zm-17.36,22.888a7.444,7.444,0,0,0,1.694,1.108,6.343,6.343,0,0,0,1.806.54l13.107-24.634a13.516,13.516,0,0,0-3.151-2.069,11.075,11.075,0,0,0-3.24-.955Z",
    transform: "translate(-150.969 -211.319)",
    fill: "url(#linear-gradient-3)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5297",
    "data-name": "Trazado 5297",
    d: "M165.066,237.843l-1.01-.206a5.665,5.665,0,0,0,5.283,2.469l-.773-.615A7.135,7.135,0,0,1,165.066,237.843Z",
    transform: "translate(-164.056 -211.319)",
    fill: "#e5e2ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5298",
    "data-name": "Trazado 5298",
    d: "M158.686,214.955l-.753-.1a12.208,12.208,0,0,0-6.391-3.024l-.573-.483a9.817,9.817,0,0,1,7.717,3.6Z",
    transform: "translate(-140.316 -211.319)",
    opacity: 0.62,
    fill: "url(#linear-gradient-4)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5299",
    "data-name": "Trazado 5299",
    d: "M160.86,212.659a28.9,28.9,0,0,1-11.658-5.428l-1.7,4.124s1.93-1.91,6.165-.184c4.955,2.019,4.684,6,4.684,6Z",
    transform: "translate(-128.86 -185.44)",
    opacity: 0.62,
    fill: "url(#linear-gradient-5)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5300",
    "data-name": "Trazado 5300",
    d: "M169.873,211.355a5.1,5.1,0,0,1,2.59-.894l-12.666,30.6-1.527-1.577Z",
    transform: "translate(-151.233 -185.44)",
    opacity: 0.5,
    fill: "url(#linear-gradient-6)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5301",
    "data-name": "Trazado 5301",
    d: "M163.122,211.355s1.329,4.088-2.486,6.027Z",
    transform: "translate(-144.482 -185.44)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2853",
    "data-name": "Grupo 2853",
    transform: "translate(170.673 54.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2848",
    "data-name": "Grupo 2848",
    transform: "translate(79.511 256.64)"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5302",
    "data-name": "Trazado 5302",
    d: "M219.673,409.1h47c4.92-27.32,16.36-62.87,16.36-62.87,2.78-1.65,8.21.38,8.21.38l17.18,62.49h42.94c2.28-38.56-18.82-82.33-18.82-82.33l.01-.01a4.725,4.725,0,0,0,.56-2.39,5.681,5.681,0,0,0-1.6-1.86c-1.16-1.06-2.54-2.12-2.54-2.12l-80.11-.5s-.81.41-1.84,1.03h-.01c-1.75,1.06-4.12,2.7-4.12,3.9a5.465,5.465,0,0,0,.81,2.96l.04.05C226.568,360.242,219.673,409.1,219.673,409.1Z",
    transform: "translate(-216.089 -319.885)",
    fill: "url(#linear-gradient-7)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_1020",
    "data-name": "Elipse 1020",
    cx: 46.31,
    cy: 17.924,
    rx: 46.31,
    ry: 17.924,
    transform: "matrix(-0.225, -0.974, 0.974, -0.225, 105.901, 106.281)",
    opacity: 0.5,
    fill: "url(#radial-gradient)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_1021",
    "data-name": "Elipse 1021",
    cx: 17.924,
    cy: 46.31,
    rx: 17.924,
    ry: 46.31,
    transform: "matrix(-0.963, -0.27, 0.27, -0.963, 34.519, 106.106)",
    opacity: 0.5,
    fill: "url(#radial-gradient-2)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2846",
    "data-name": "Grupo 2846",
    transform: "translate(74.991 26.531)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5303",
    "data-name": "Trazado 5303",
    d: "M279.636,409.137l.494-.084c-5.466-32.2-19.338-59.2-19.478-59.474l-.057-.073-3.534-3.09-.329.377,3.5,3.058C260.853,351.069,274.285,377.607,279.636,409.137Z",
    transform: "translate(-256.732 -346.416)",
    fill: "url(#linear-gradient-8)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2847",
    "data-name": "Grupo 2847",
    transform: "translate(43.713 26.533)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5304",
    "data-name": "Trazado 5304",
    d: "M288.5,409.137c5.357-31.552,19.159-58.347,19.78-59.538l3.128-2.808-.334-.373-3.216,2.908c-.143.272-14.384,27.527-19.85,59.727Z",
    transform: "translate(-288.008 -346.418)",
    fill: "url(#linear-gradient-9)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5305",
    "data-name": "Trazado 5305",
    d: "M236.615,324.815a5.465,5.465,0,0,0,.81,2.96l.04.05c16.68,3.77,29.37,19.34,29.37,19.34-9.09,17.44-24.25,61.93-24.25,61.93h17.81c4.92-27.32,16.36-62.87,16.36-62.87,2.78-1.65,8.21.38,8.21.38l17.18,62.49h11.12c-3.98-26.18-15.73-58.14-15.73-58.14,11.55-13.45,28.73-24.19,28.73-24.19l.01-.01,2.04-1.28-1.48-1.11c-7.43,7.13-31.39,16.44-32.13,16.73l30.53-18.59c-1.16-1.06-2.54-2.12-2.54-2.12l-80.11-.5s-.81.41-1.84,1.03l21.88,12.04Z",
    transform: "translate(-209.809 -319.885)",
    opacity: 0.76,
    fill: "url(#linear-gradient-10)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5306",
    "data-name": "Trazado 5306",
    d: "M297.526,346.225l-9.351-6.067,2.221,6.067,1.628,18.265Z",
    transform: "translate(-230.581 -319.885)",
    opacity: 0.76,
    fill: "url(#linear-gradient-10)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5307",
    "data-name": "Trazado 5307",
    d: "M249.372,346.6l9.74-5.51,20.854-9.391-26.555,17.549-1.582,6.29Z",
    transform: "translate(-174.216 -319.885)",
    opacity: 0.76,
    fill: "url(#linear-gradient-10)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5308",
    "data-name": "Trazado 5308",
    d: "M270.445,158.745c-.06.43-.11.66-.11.66a57.265,57.265,0,0,0,1.66,5.66,46,46,0,0,0,6.23,12.12,23.855,23.855,0,0,0,2.72,3.18c14.59-4.58,21.78-18.85,24.54-25.95a.358.358,0,0,0,.04-.11c.53-1.34.88-2.42,1.1-3.12v-.01c.17-.56.25-.87.25-.87-.06-.12-.12-.25-.18-.37l-.03-.05c-.24-.5-.48-1.01-.7-1.5a71.163,71.163,0,0,1-4-11.17c-.71-2.62-1.09-4.64-1.27-5.71-.09-.55-.13-.85-.13-.85l-6.8,3.59-23.43,12.4a38.548,38.548,0,0,1,.5,5.94c.02,1.25-.02,2.37-.09,3.32-.07,1.16-.19,2.08-.28,2.68v.01A.68.68,0,0,1,270.445,158.745Z",
    transform: "translate(-142.578 -63.245)",
    fill: "#fe9083"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5309",
    "data-name": "Trazado 5309",
    d: "M277.429,181.935a20.1,20.1,0,0,0,4.84,3.54.745.745,0,0,0,.12.07s.05-.03.14-.08l.01-.01c.51-.31,2.25-1.38,4.59-3.14,6.12-4.61,16.34-13.93,19.26-26.49.01-.02.01-.03.02-.05a31.141,31.141,0,0,0,.7-4.59v-.01c.03-.41.06-.82.07-1.24a64.431,64.431,0,0,1-5.55,9.92c-4.14,6.06-10.35,12.67-17.77,12.71-6.42.04-9.71-4.35-11.38-8.4a22.917,22.917,0,0,1-1.35-4.6.031.031,0,0,1-.01-.02c-.07-.36-.12-.68-.17-.95v-.01c-.02-.14-.04-.26-.05-.37-.06-.45-.08-.71-.08-.71S268.359,172.865,277.429,181.935Z",
    transform: "translate(-143.062 -63.245)",
    fill: "url(#linear-gradient-13)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5310",
    "data-name": "Trazado 5310",
    d: "M277.429,181.935a20.1,20.1,0,0,0,4.84,3.54h.12l.14-.01.01-.01c.51-.31,2.25-1.38,4.59-3.14,6.12-4.61,16.34-13.93,19.26-26.49.01-.02.01-.03.02-.05a31.141,31.141,0,0,0,.7-4.59v-.01c.03-.41.06-.82.07-1.24a64.431,64.431,0,0,1-5.55,9.92s-4.04,11.1-12.78,16.6c-4.38,2.75-7.7,2.35-10.14.73a15.086,15.086,0,0,1-4.95-6.54,15.377,15.377,0,0,1-1.28-5.58q-.015-.5,0-.9a22.917,22.917,0,0,1-1.35-4.6.031.031,0,0,1-.01-.02c-.07-.36-.12-.68-.17-.95v-.01c-.02-.14-.04-.26-.05-.37-.06-.45-.08-.71-.08-.71S268.359,172.865,277.429,181.935Z",
    transform: "translate(-143.062 -63.245)",
    opacity: 0.5,
    fill: "url(#linear-gradient-14)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5311",
    "data-name": "Trazado 5311",
    d: "M200.3,272.625a1.773,1.773,0,0,1,.16.08c.82.1,3.37-.46,6.71-3.35l.01-.01q0-.015.03-.03c.01-.01.02-.03.04-.04,2.8-2.45,6.16-6.54,9.51-13.24,6.7-13.39,8.62-22.33,8.93-23.89l.04-.24,3.91,6.2c2.65,7.97,7.67,40.95,7.58,42.37s-4.45,8.34-4.36,9.19a.031.031,0,0,0,.01.02c.12.86,2.08,2.75,2.64,4.81.38,1.37-2.28,5.69-4.15,8.92v.01a13.134,13.134,0,0,0-1.72,3.58c0,1.51,4.74,8.9,4.74,8.9v3.98l.07.07.22.2.18.15c1.8,1.42,9.43,6.07,33.27,7.35,28.25,1.51,47.07-7.58,47.07-7.58l-1.42-3.89s1.32-1.13,1.42-1.7-1.04-1.9-1.04-1.9,2.84-1.51,2.84-3.41-5.69-7.76-5.5-12.79,4.55-9.47,5.12-12.31-7.39-9.85-7.39-9.85c6.82-21.6,8.15-50.59,8.15-50.59l1.32-1.52s8.15,18.57,15.54,27.66c.88,1.08,1.81,2.15,2.77,3.18a80.982,80.982,0,0,0,6.36,6.15c5.12,4.46,9.77,7.39,10.95,7.16,1.9-.38,9.48-15.35,9.13-30.7-.16-7.3-4.56-15.47-9.13-22.02-.49-.7-.98-1.39-1.48-2.06a104.893,104.893,0,0,0-7.84-9.45c-.58-.62-.91-.95-.91-.95s1.04-3.35,1.75-6.26a1.6,1.6,0,0,1,.05-.21.355.355,0,0,1,.02-.1.312.312,0,0,1,.02-.07c.42-1.79.68-3.34.44-3.72-.63-1.01-4.3-2.15-4.93-2.9s-3.28-13.52-5.3-14.91c-1.94-1.33-5.35-2.3-16.72-6.77-.56-.22-1.13-.44-1.73-.68-12.75-5.05-25.26-11.18-25.26-11.18l-4.8-5.9h-2.14l.7,1.5.03.05c-.34,1.52-.73,2.98-1.17,4.37a.358.358,0,0,1-.04.11c-6.6,20.82-23.58,27.53-23.58,27.53-11.8-8.71-11.57-22.54-11.57-22.54v-1.9l-2.21.66-1.51,3.6s-2.56,3.98-12.7,8.44a60.33,60.33,0,0,0-5.57,2.85c-9.28,5.27-19.6,13.42-20.39,15.15a5.61,5.61,0,0,0-.27.86v.01c-1.09,4.28-3.33,20.31-5.41,26.03a13.1,13.1,0,0,1-4.86,6.56c-.01.01-.01.01-.02.01a7.608,7.608,0,0,1-1.94,1.01q-.24,1.32-.45,2.61C190.171,252.715,198.441,271.325,200.3,272.625Z",
    transform: "translate(-122.094 -63.245)",
    fill: "url(#linear-gradient-15)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5312",
    "data-name": "Trazado 5312",
    d: "M203.895,220.865l8.24,2.77,1.32-1.52s8.15,18.57,15.54,27.66c.88,1.08,1.81,2.15,2.77,3.18a80.982,80.982,0,0,0,6.36,6.15l6.28-27.07,3.19-20.55a104.889,104.889,0,0,0-7.84-9.45c-.58-.62-.91-.95-.91-.95s1.04-3.35,1.75-6.26a1.6,1.6,0,0,1,.05-.21.355.355,0,0,1,.02-.1.312.312,0,0,1,.02-.07c.42-1.79.68-3.34.44-3.72-.63-1.01-4.3-2.15-4.93-2.9s-3.28-13.52-5.3-14.91c0,0,1.32,12.25-5.69,27.79l-3.41,4.8-9.98,8.02S208.025,218.555,203.895,220.865Z",
    transform: "translate(-16.858 -63.245)",
    opacity: 0.5,
    fill: "url(#linear-gradient-14)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5313",
    "data-name": "Trazado 5313",
    d: "M181.332,243.025c1.77,13.13,21.34,23.24,21.34,23.24,4.36,0,9.23-7.58,13.65-16.93s4.69-36.21,4.92-37.87,2.7-4.98,2.85-6.4-3.98-4.36-3.98-4.36l.03-.07.03-.07c.43-.92,2.85-6.11,2.68-7.06-.19-1.04-4.82-3.31-4.82-3.31l-.29,5.11s-10.78-2.04-14.43-10.39l-.64-2.56-1.8,1.2v10.99s-.37,1.71-.94,1.71-4.77-2.1-5.65-1.81-1.76,6.17-2.94,6.92-4.3,2.94-4.77,3.98a19.048,19.048,0,0,0-.25,4.15,42.4,42.4,0,0,1-.41,6.94C185.242,219.365,179.562,229.885,181.332,243.025Z",
    transform: "translate(29.545 -63.245)",
    fill: "url(#linear-gradient-17)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5314",
    "data-name": "Trazado 5314",
    d: "M347.231,231.775c.88,1.39,5.3,4.3,6.44,5.44s0,4.87,0,4.87a153.347,153.347,0,0,0,39.88,30.54,1.773,1.773,0,0,1,.16.08c11.66-7.84,10.66-20.75,6.79-31.63a82.1,82.1,0,0,0-10.32-19.38l-.01-.01-.01-.01a24.407,24.407,0,0,0-5.92-1.64,3.6,3.6,0,0,0-2.19.68c-1.42.88-2.62,2.27-3.78,1.69-1.71-.86-5.53-9.89-8.12-10.14-1.81-.17-4.32,1.67-5.99,2.72-.73.46-1.3.77-1.58.69-.95-.25-4.17-4.11-4.43-4.21s-1.72.97-1.72.97l1.03,1.28a34.987,34.987,0,0,1-6.76,15.22l-3.47-5.08S346.341,230.385,347.231,231.775Z",
    transform: "translate(-315.344 -63.245)",
    fill: "url(#linear-gradient-18)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5315",
    "data-name": "Trazado 5315",
    d: "M275.245,158.355c.02.13.04.26.05.39a7.735,7.735,0,0,0,.19.8.031.031,0,0,0,.01.02c1.19,4.41,6,8.92,12.07,6.75,6.63-2.37,19.25-29.1,19.25-29.1l-1.27-5.71L275.6,155.9l-.33,2.31Z",
    transform: "translate(-147.428 -63.245)",
    fill: "#cb4d7a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2849",
    "data-name": "Grupo 2849",
    transform: "translate(220.888 56.408)"
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5316",
    "data-name": "Trazado 5316",
    d: "M178.63,153.463s1.831-10.1,1.01-17.558a80.721,80.721,0,0,1,.212-15.916,4.067,4.067,0,0,1,3.136,0c1.326.758,4.421,8.464,3.031,14.653s-.316,21.032-.316,21.032h2.085l4.547-6.253,2.211-.632s12.726,12,12.536,19.137l-1.662,6.348-15.674-.537-10.232-11.684Z",
    transform: "translate(-171.97 -119.653)",
    fill: "#ee8183"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5317",
    "data-name": "Trazado 5317",
    d: "M177.289,148.789a81.492,81.492,0,0,1-2.115,14.779,3.537,3.537,0,0,0,3.567,2.985l.805-.9s.569,3.173,3.458,3.41l2.748-2.747-.711,2.273a3.891,3.891,0,0,0,3.6,2.322s4.358-3.411,4.642-7.864l-4.308-3.647V156.6l-5.118-3.6-.1-2.037A12.024,12.024,0,0,0,177.289,148.789Z",
    transform: "translate(-154.713 -119.653)",
    fill: "url(#linear-gradient-19)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5318",
    "data-name": "Trazado 5318",
    d: "M190.063,133.766a7.144,7.144,0,0,0,1.857,2.708,16.005,16.005,0,0,0,4.246,1.337l.143,17.863h2.085l4.547-6.253s-2.305,3.568-2.447,6.253l1.8.884,1.563-5.353.741,3.853-.737,4.793a12.579,12.579,0,0,0-7.575-2.415l-.734,1.332s8.826,7.311,10.863,11.621c0,0-4.358-5.542-14.306-11.652l-.947-2.937-1.257-7.011S191.1,138.685,190.063,133.766Z",
    transform: "translate(-182.576 -119.653)",
    opacity: 0.6,
    fill: "url(#linear-gradient-20)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5319",
    "data-name": "Trazado 5319",
    d: "M180.289,164.9c.82,2.46,9.41,12.69,10.36,14.91a30.03,30.03,0,0,1,1.52,5.11c4.22,9.13,14.43,10.39,14.43,10.39l.47-8.24s5.49-3.16,6.42-4.89l.01-.03.11-.29a68.8,68.8,0,0,0,.04-7.58l-9.61-3.89c-4.17-5.4-14.31-11.65-14.31-11.65l-.47-2.83c7.28-3.58,6.06-14.41,4.83-15.74a5.4,5.4,0,0,0-3.5-1.32s-2.66,8.71-4.36,12.79S179.469,162.435,180.289,164.9Z",
    transform: "translate(-180.199 -119.653)",
    fill: "url(#linear-gradient-19)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5320",
    "data-name": "Trazado 5320",
    d: "M188.816,150.968s-1.073,9.948-4.216,14.685a23.173,23.173,0,0,0,4.311-12.648Z",
    transform: "translate(-159.767 -119.653)",
    fill: "#e28183"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5321",
    "data-name": "Trazado 5321",
    d: "M185.453,156.6s-1.044,8.006-5.971,12.458c0,0,4.363-2.179,5.971-9.663Z",
    transform: "translate(-151.191 -119.653)",
    fill: "#e28183"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5322",
    "data-name": "Trazado 5322",
    d: "M186.875,177.683s10.834,10.52,17.752,9.382l-.47,8.24a18.283,18.283,0,0,1-15.066-12.955A31.1,31.1,0,0,0,186.875,177.683Z",
    transform: "translate(-177.758 -119.653)",
    opacity: 0.91,
    fill: "url(#linear-gradient-22)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2850",
    "data-name": "Grupo 2850",
    transform: "translate(0 90.949)"
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5323",
    "data-name": "Trazado 5323",
    d: "M374.937,191.985s9.95,18.19,21.6,23.78h3.98l9.19,13.93s5.94-3.73,6.38-15.98a11.174,11.174,0,0,1-2.59-4.62s3.28-2.58,4.17-4.47,1.2-7.58,1.83-9.92,6-7.2,7.2-7.83,6.63-.95,6.63-.95.76-1.96,0-2.9-9.22-4.24-13.83-1.08a20.766,20.766,0,0,1-.82,3.67c-.51,1.26-4.55,5.74-5.18,5.74s-3.35-2.27-4.55-4.04a178.56,178.56,0,0,1-8.74-19.32.5.5,0,0,0-.04-.13c-.02-.07-.05-.14-.06-.2a.927.927,0,0,1-.04-.13c-.01-.02-.02-.03-.02-.05-1.14-3.85-7.77-11.24-11.31-13.26a2.085,2.085,0,0,0-2.33,1.51s2.84,8.09,5.81,12.89c.5.81,1.04,1.76,1.6,2.78h.01c2.53,4.65,5.38,10.74,5.79,11.63l.05.11-1.58.81-4.27-4.05-4.38-4.15-10.05,10.61.99,1.26,3.14,4.03-1.59.29-3.7-4.09Z",
    transform: "translate(-373.97 -154.194)",
    fill: "url(#linear-gradient-19)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5324",
    "data-name": "Trazado 5324",
    d: "M395.105,195.851l3.179,4.673s17.453-13.459,21.243-14.6,5.18-.38,5.18-.38l3.91,4.99s-7.2,6.38-7.83,14.97c0,0,2.4-10.86,10.55-14.15-.63,0-3.35-2.27-4.55-4.04a178.56,178.56,0,0,1-8.74-19.32,4.962,4.962,0,0,1-.16,3.41c-.86,1.59-5.92.09-6.22,0h-.01l5.8,11.63.05.11-1.58.81-4.27-4.05,2.14,4.97-15.58,2.75,3.14,4.03-1.59.29Z",
    transform: "translate(-391.81 -154.194)",
    opacity: 0.6,
    fill: "url(#linear-gradient-20)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5325",
    "data-name": "Trazado 5325",
    d: "M422.074,175.758s-3.032-.442-4.99,3.474l.442,1.263s-2.955.579-5.81,5.368a16.188,16.188,0,0,0,8.779,6.695s2.9-.821,3.41-3.284l-.568-1.579,2.273,1.7s2.716.821,3.916-3.221Z",
    transform: "translate(-406.61 -154.194)",
    fill: "url(#linear-gradient-25)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5326",
    "data-name": "Trazado 5326",
    d: "M426.169,190.726a4.685,4.685,0,0,1,2.463-4.8l6,6.632a3.1,3.1,0,0,1-2.779,2.589S427.748,193.758,426.169,190.726Z",
    transform: "translate(-426.116 -154.194)",
    fill: "url(#linear-gradient-25)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5327",
    "data-name": "Trazado 5327",
    d: "M408.085,204.625a44.5,44.5,0,0,1-17.15,11.14l4.395,6.662L404.5,210.78l-.587-1.685S407.582,206.337,408.085,204.625Z",
    transform: "translate(-364.388 -154.194)",
    opacity: 0.91,
    fill: "url(#linear-gradient-22)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5328",
    "data-name": "Trazado 5328",
    d: "M418.672,180.495s2.9,4.8,5.811,7.2l.568,1.579s-5.639-3.806-7.714-8.2A3.594,3.594,0,0,1,418.672,180.495Z",
    transform: "translate(-407.756 -154.194)",
    fill: "#e28183"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5329",
    "data-name": "Trazado 5329",
    d: "M331.391,231.775c.88,1.39,5.3,4.3,6.44,5.44s0,4.87,0,4.87a153.347,153.347,0,0,0,39.88,30.54,1.773,1.773,0,0,1,.16.08c1.52.19,8.91-1.89,16.3-16.67,6.7-13.39,8.62-22.33,8.93-23.89l.04-.24-1.63-2.21-2.42-27.28-1.7,5.49c-6.44-7.77-12.51-19.7-12.51-19.7l-.27.86v.01c-1.09,4.28-3.33,20.31-5.41,26.03a13.1,13.1,0,0,1-4.86,6.56l-.01.02.01.01c5.93,5.41,8.87,13.19,10.32,19.38a53.68,53.68,0,0,1,1.42,10.03,67.435,67.435,0,0,0-6.82-16.96,36.5,36.5,0,0,0-7.33-8.85,58.855,58.855,0,0,0-5.72-4.58c-1.42.88-2.62,2.27-3.78,1.69,7.8,11.71,7.61,34.89.28,30.47s-9-13.8-9-13.8c1.73-11.43,1.214-24.322-.176-26.772-1.687.056-6.518,3.453-6.8,3.373a39.6,39.6,0,0,1-5.88,22.43l-4.17-6.45a40.011,40.011,0,0,0,5.62-20.19c-.25-.11-1.72.97-1.72.97l1.03,1.28a34.987,34.987,0,0,1-6.76,15.22l-3.47-5.08S330.5,230.385,331.391,231.775Z",
    transform: "translate(-299.503 -63.245)",
    opacity: 0.5,
    fill: "url(#linear-gradient-10)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5330",
    "data-name": "Trazado 5330",
    d: "M180.995,315.9v3.98l.07.07.22.2.18.15c1.8,1.42,9.43,6.07,33.27,7.35,28.25,1.51,47.07-7.58,47.07-7.58l-1.42-3.89s1.32-1.13,1.42-1.7-1.04-1.9-1.04-1.9,2.84-1.51,2.84-3.41c0-1.71-4.64-6.66-5.39-11.31a6.759,6.759,0,0,1-.11-1.48c.19-5,4.51-9.43,5.11-12.27a.158.158,0,0,0,.01-.04c.57-2.84-7.39-9.85-7.39-9.85,6.82-21.6,8.15-50.59,8.15-50.59l1.32-1.52s8.15,18.57,15.54,27.66,18.19,16.87,20.08,16.49c4.36,0,9.23-7.58,13.65-16.93s4.69-36.21,4.92-37.87,2.7-4.98,2.85-6.4c-4.74,8.15-12.29,5.75-12.29,5.75,5.47.12,8.31-10.11,8.31-10.11l.03-.07.03-.07,2.67-7.05c-.3.34-6.55,7.33-12.59,3.02-6.19-4.42-9.38-12.98-9.38-12.98v10.99s-.37,1.71-.94,1.71a134.151,134.151,0,0,0,2.74,17.29c2.81,13.13,6.66,25.81,6.66,25.81s-10.44-5.68-14.11-20.08a60.738,60.738,0,0,1-1.87-17.24,43.218,43.218,0,0,1,.84-7.21,1.6,1.6,0,0,1,.05-.21.355.355,0,0,1,.02-.1.434.434,0,0,1,.01-.05l-1.01,2.14-1.92,4.76c-2.23,18.48,2.37,46.33,2.37,46.33-6.7-8.34-8.09-26.78-7.8-31.26.13-2.14.3-4.78.41-6.94.15-2.36.25-4.15.25-4.15l-13.71,8.18,2.53-8.02-9.98,8.02s-8.97,10.8-18.19,12.06-43.07.51-43.07.51,29.43,1.89,38.02,4.42,10.23,5.43,10.23,5.43c-6.21,31.59-40.58,42.24-41.65,42.56,31.18-4.68,45.69-31.19,45.69-31.19s.51,14.91-1.89,20.59-16.55,19.58-34.74,22.48a41.893,41.893,0,0,1-4.53.46c-15.34.72-28.04-7.12-29.34-7.96a.93.93,0,0,0-.11-.07.523.523,0,0,0,.03.05c.49.75,6.78,9.59,32.18,10.56,1.54.06,3.04.05,4.5-.01h.02c23.54-.99,35.53-16.67,35.53-16.67s8.71,4.68,3.15,11.62c-.06.07-.12.15-.18.22-1.64,1.89-5.25,4.2-9.52,6.58-.12.07-.24.14-.35.2-5.16,2.85-11.21,5.79-15.89,8.22a.492.492,0,0,0-.07.03,59.24,59.24,0,0,0-6.52,3.73.01.01,0,0,0-.01.01c-1.32.96-1.59,1.58-.3,1.73,6.57.76,31.45-4.67,32.46-3.16s-1.23,5.43-1.23,5.43c-22.84,11.32-71.71,5.74-73.25,5.57,40.9,10.47,74.36-2.79,74.36-2.79l-1.11,3.92a146.327,146.327,0,0,1-39.69,6.82c-21.48.5-34.87-4.99-34.87-4.99Z",
    transform: "translate(-68.708 -63.245)",
    opacity: 0.5,
    fill: "url(#linear-gradient-14)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5331",
    "data-name": "Trazado 5331",
    d: "M332.629,225.968s-16.267.885-27.018,3.727l5.545,8.409A73.753,73.753,0,0,1,332.629,225.968Z",
    transform: "translate(-203.608 -63.245)",
    opacity: 0.5,
    fill: "url(#linear-gradient-30)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5332",
    "data-name": "Trazado 5332",
    d: "M281.105,270.807s10.148,8.467,20.127,12.382a67.373,67.373,0,0,0,19.579,4.3s-5.737,1.7-19.853-.568S282.012,277,282.012,277Z",
    transform: "translate(-167.284 -63.245)",
    opacity: 0.5,
    fill: "url(#linear-gradient-30)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5333",
    "data-name": "Trazado 5333",
    d: "M282.944,303.415v.01c18.78,4.85,42.62-2.11,42.42-2.96s-6.53.38-21.21-2.56c-14.23-2.85-19.39-7.91-19.7-8.22.12.86,2.08,2.75,2.64,4.81C287.474,295.865,284.814,300.185,282.944,303.415Z",
    transform: "translate(-173.677 -63.245)",
    opacity: 0.5,
    fill: "url(#linear-gradient-30)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5334",
    "data-name": "Trazado 5334",
    d: "M218.515,228.515c16.04,1.63,20.36,6.1,20.36,6.1,4.51.57,14.64-10.98,14.64-10.98l1.32-1.52s8.15,18.57,15.54,27.66c.88,1.08,1.81,2.15,2.77,3.18l-1.05-2.36s-1.72-.82-2.22-9.85,3.79-22.48,3.82-24.31.66-11.09.66-11.09l-13.71,8.18,2.53-8.02-9.98,8.02s-3.91,5.88-13.78,10.78C230.1,228.935,219.665,228.565,218.515,228.515Z",
    transform: "translate(-58.238 -63.245)",
    opacity: 0.5,
    fill: "url(#linear-gradient-33)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5335",
    "data-name": "Trazado 5335",
    d: "M262.5,222.115l-9.556-1.248a71.788,71.788,0,0,1-11.487,5.651l6.393,9.427s-2.536,13.438-9.816,21.012c0,0,19.321-10.732,22.037-19.755Z",
    transform: "translate(-65.904 -63.245)",
    opacity: 0.5,
    fill: "url(#linear-gradient-33)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5336",
    "data-name": "Trazado 5336",
    d: "M204.215,193.515l-2.73,7.19s-2.785,9.7-8.31,10.11-10.93-16.27-10.93-16.27v-10.99s5.878,12.6,12.226,14.024S204.215,193.515,204.215,193.515Z",
    transform: "translate(48.172 -63.245)",
    opacity: 0.5,
    fill: "url(#linear-gradient-33)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5337",
    "data-name": "Trazado 5337",
    d: "M226.284,187.825s-4.926,9.849-10.989,12.88c0,0,7.209-17.5,5.689-27.79C220.984,172.915,223.634,174.565,226.284,187.825Z",
    transform: "translate(-6.947 -63.245)",
    opacity: 0.5,
    fill: "url(#linear-gradient-30)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5338",
    "data-name": "Trazado 5338",
    d: "M334.46,202.415l-1.7,5.49-1.725,45.05a108.667,108.667,0,0,0,7.435-20.81l-1.594-2.45S334.2,212.714,334.46,202.415Z",
    transform: "translate(-234.873 -63.245)",
    opacity: 0.76,
    fill: "url(#linear-gradient-10)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5339",
    "data-name": "Trazado 5339",
    d: "M395.751,215.675s.961,22.13-8.443,24.043l-.467,2.367S399.008,241.634,395.751,215.675Z",
    transform: "translate(-348.514 -63.245)",
    opacity: 0.5,
    fill: "url(#linear-gradient-10)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5340",
    "data-name": "Trazado 5340",
    d: "M351.537,222.4s.36.793,3.78-1.69c0,0,11.83,8.379,16.388,20.19,0,0-7.292-10.851-11.172-12.025s-4.817,3.156-4.817,3.156S354.181,225.936,351.537,222.4Z",
    transform: "translate(-288.61 -63.245)",
    opacity: 0.3,
    fill: "url(#linear-gradient-10)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5341",
    "data-name": "Trazado 5341",
    d: "M194.05,205.065s-4.552,8.39-13.079,5.757c0,0,5.11,3.444,10.229.643C191.2,211.465,194.377,206.012,194.05,205.065Z",
    transform: "translate(59.587 -63.245)",
    opacity: 0.5,
    fill: "url(#linear-gradient-33)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5342",
    "data-name": "Trazado 5342",
    d: "M204.3,194.445s-6.258,23.4,10.068,40.977a27.124,27.124,0,0,1-13.008-18.043A38.746,38.746,0,0,1,204.3,194.445Z",
    transform: "translate(19.529 -63.245)",
    opacity: 0.5,
    fill: "url(#linear-gradient-10)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5343",
    "data-name": "Trazado 5343",
    d: "M303,175.743s.705,10.562,5.767,18.141,15.1,12.695,15.1,12.695-12.6-4.642-18.379-11.179S303,175.743,303,175.743Z",
    transform: "translate(-191.318 -63.245)",
    opacity: 0.5,
    fill: "url(#linear-gradient-33)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5344",
    "data-name": "Trazado 5344",
    d: "M286.659,159.851a66.785,66.785,0,0,1-2.842,17.832c-2.842,9-27.512,24.728-27.512,24.728s25.428-10.563,30.354-20.061S286.659,159.851,286.659,159.851Z",
    transform: "translate(-110.522 -63.245)",
    opacity: 0.5,
    fill: "url(#linear-gradient-33)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5345",
    "data-name": "Trazado 5345",
    d: "M329.291,201.91v14.384s-33.11-.267-70.237,2.193l-.848-12.947A647.306,647.306,0,0,1,329.291,201.91Z",
    transform: "translate(-152.865 -63.245)",
    fill: "url(#linear-gradient-44)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5352",
    "data-name": "Trazado 5352",
    d: "M264.335,161.765c.78,9.3,3.61,15.78,6.63,20.15,4.16,6,8.66,8.05,8.66,8.05a51.957,51.957,0,0,0,11.76-7.09,59.967,59.967,0,0,0,19.21-28.5c-6.02,14.54-14.86,23.35-21.56,28.31a43.276,43.276,0,0,1-9.41,5.52v-4.65a30.9,30.9,0,0,0,3.1-1.36c11.8-5.95,18-18.35,20.9-26.37.01-.02.01-.03.02-.05a56.964,56.964,0,0,0,2.18-7.39h-2.14l.7,1.5.03.05c-.34,1.52-.73,2.98-1.17,4.37a.358.358,0,0,1-.04.11c-6.6,20.82-23.58,27.53-23.58,27.53-11.8-8.71-11.57-22.54-11.57-22.54v-1.9l-2.21.66Z",
    transform: "translate(-140.298 -63.245)",
    opacity: 0.5,
    fill: "url(#linear-gradient-14)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5353",
    "data-name": "Trazado 5353",
    d: "M385.916,212.3s3.208,10.477.176,26.772c0,0-1.516-20.653-2.653-22.453s-4.321-.946-4.321-.946A74.32,74.32,0,0,1,385.916,212.3Z",
    transform: "translate(-331.88 -63.245)",
    opacity: 0.3,
    fill: "url(#linear-gradient-10)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5354",
    "data-name": "Trazado 5354",
    d: "M341.355,269.275c2.8-2.45,6.16-6.54,9.51-13.24,6.7-13.39,8.62-22.33,8.93-23.89l-1.59-2.45-2.13-20.6-1.99-1.19a84.279,84.279,0,0,1-12.51-19.7,5.61,5.61,0,0,0-.27.86v.01c-1.09,4.28-3.33,20.31-5.41,26.03a13.1,13.1,0,0,1-4.86,6.56s12.31,18.26,12.91,31.29C344.475,264.815,341.835,268.675,341.355,269.275Z",
    transform: "translate(-256.198 -63.245)",
    opacity: 0.5,
    fill: "url(#linear-gradient-10)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5355",
    "data-name": "Trazado 5355",
    d: "M240.125,307.355s22.19-3.64,31.25-9.48a.01.01,0,0,0,.01-.01,6.757,6.757,0,0,1-.11-1.48c.19-5,4.51-9.43,5.11-12.27-.1.27-.75,1.77-3.9,4.47a66.944,66.944,0,0,1-9.52,6.58c-.12.07-.24.14-.35.2-6.4,3.78-11.91,6.34-15.89,8.22a.492.492,0,0,0-.07.03c-3.58,1.68-5.9,2.79-6.52,3.73A.01.01,0,0,0,240.125,307.355Z",
    transform: "translate(-81.878 -63.245)",
    opacity: 0.5,
    fill: "url(#linear-gradient-10)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5356",
    "data-name": "Trazado 5356",
    d: "M282.945,289.685c.12.86,2.08,2.75,2.64,4.81,0,0,8.14,8.62,38.27,5.97-.2-.85-6.53.38-21.21-2.56C288.415,295.055,283.255,289.995,282.945,289.685Z",
    transform: "translate(-172.168 -63.245)",
    opacity: 0.5,
    fill: "url(#linear-gradient-10)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5357",
    "data-name": "Trazado 5357",
    d: "M237.315,173.055l19.26,6.24,5.64,2.62.03.01,3.67.01,4.96.01,3.1.25,1.64.12,4.67.37,2.35.19,23.1-8.36,4.13-1.49,19-6.88c-.56-.22-1.13-.44-1.73-.68-12.75-5.05-25.26-11.18-25.26-11.18l-4.8-5.9h-2.14a71.163,71.163,0,0,1-4-11.17l-1.27-5.71c-.09-.55-.13-.85-.13-.85l-6.8,3.59-22.93,18.34c.02,1.25-.02,2.37-.09,3.32l-.33,2.31c-.06-.45-.08-.71-.08-.71l-2.21.66-1.51,3.6s-2.56,3.98-12.7,8.44A60.33,60.33,0,0,0,237.315,173.055Z",
    transform: "translate(-131.548 -63.245)",
    fill: "#7a4ac0",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2852",
    "data-name": "Grupo 2852",
    transform: "translate(102.004)"
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5358",
    "data-name": "Trazado 5358",
    d: "M291.61,155.485a31.369,31.369,0,0,0,18.89-2.78c9.91-4.8,18.24-18.95,18.75-22.48s-3.79-12.76-3.79-19.96,3.53-19.58-2.4-26.28-33.22-7.7-42.07.89c0,0-2.74,6.88-2.74,10.77a28.334,28.334,0,0,0,.42,3.91c.08.59.19,1.22.29,1.87.79,4.71,1.88,10.46,1.37,12.98a12.639,12.639,0,0,1-.79,2.46v.01c-1.09,2.52-2.71,4.53-3,6.71C276.16,126.435,279.98,146.645,291.61,155.485Z",
    transform: "translate(-273.177 -63.245)",
    fill: "url(#linear-gradient-19)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5359",
    "data-name": "Trazado 5359",
    d: "M267.97,108.232s2.451-6.148,8.609-6.243c0,0,3.6,1.422,4.168,4.169,0,0-1.326,9.947-2.842,14.589s-7.074,3.971-7.074,3.971A23.562,23.562,0,0,1,267.97,108.232Z",
    transform: "translate(-215.613 -63.245)",
    fill: "url(#linear-gradient-19)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5360",
    "data-name": "Trazado 5360",
    d: "M324.548,128.486a5.611,5.611,0,0,0-2.935.5c-.884.664-4.105,3.79-8.179,4.643s-6.806-2.616-7.673-2.795-1.822,1.05-1.822,1.05a3.42,3.42,0,0,1,2.495-2.063s.859,3.268,6.764,2.15,8.415-3.742,8.415-3.742l.3-.537A15.737,15.737,0,0,1,324.548,128.486Z",
    transform: "translate(-295.859 -63.245)",
    fill: "url(#linear-gradient-52)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5361",
    "data-name": "Trazado 5361",
    d: "M314.813,97.893l-.08-.631s-5.89-10.336-17.543-10.62S282.9,93.66,282.9,93.66l-2.158-3.276,4.918-10,34.236-.568,8.337,6.726,1.053,16.466-3.706,21.739-9.019,4.806L314.02,127.3c.941-7.279,6.355-13.929,6.355-13.929l-3.947-2.741s-10.137,4.907-16,3.438c0,0-4.406-12.858-4.153-22.384C296.28,91.684,311.3,93.906,314.813,97.893Z",
    transform: "translate(-277.41 -63.245)",
    opacity: 0.6,
    fill: "url(#linear-gradient-20)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5362",
    "data-name": "Trazado 5362",
    d: "M314.243,98.659s-.568-3.724-6.853-5.213c-7-1.659-12.686-3.062-12.686-3.062s1.239,4.082,3.572,5.613c0,0,7.406-.269,11.155.584S314.243,98.659,314.243,98.659Z",
    transform: "translate(-276.319 -63.245)",
    fill: "#38368e"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5363",
    "data-name": "Trazado 5363",
    d: "M321.614,93.66s3.554,2.74,5.97,9.277c0,0-2.321-3.032-4.453-2.984a1.217,1.217,0,0,0-1.227,1.475A13.661,13.661,0,0,1,321.614,93.66Z",
    transform: "translate(-316.118 -63.245)",
    fill: "#38368e"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5364",
    "data-name": "Trazado 5364",
    d: "M308.137,109.189s-.379-7.863-8.052-9.852a16.074,16.074,0,0,0-3.032,7.579S301.127,106.158,308.137,109.189Z",
    transform: "translate(-272.562 -63.245)",
    fill: "url(#linear-gradient-54)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5365",
    "data-name": "Trazado 5365",
    d: "M325.462,112.316s-.62-6.26-4.215-8.574c0,0-2.451,1.836-2.2,7.076C319.051,110.818,321.2,110.042,325.462,112.316Z",
    transform: "translate(-311.866 -63.245)",
    fill: "url(#linear-gradient-55)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5366",
    "data-name": "Trazado 5366",
    d: "M307.737,109.189s-2.494,3.064-9.473,3.664a10.9,10.9,0,0,1-1.2-5.986S303.474,106.253,307.737,109.189Z",
    transform: "translate(-272.161 -63.245)",
    fill: "#ffebed"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5367",
    "data-name": "Trazado 5367",
    d: "M325.3,112.316v.916s-1.073,2.242-4.926,2.621a10.74,10.74,0,0,1-1.346-5.073S321.483,110.168,325.3,112.316Z",
    transform: "translate(-311.708 -63.245)",
    fill: "#ffebed"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5368",
    "data-name": "Trazado 5368",
    d: "M306.153,106.7a8.652,8.652,0,0,1,1.61,5.548,26.531,26.531,0,0,1-3.623.6,9.423,9.423,0,0,1-1.2-5.986A9.682,9.682,0,0,1,306.153,106.7Z",
    transform: "translate(-278.038 -63.245)",
    fill: "#7f9ec9"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5369",
    "data-name": "Trazado 5369",
    d: "M324.113,110.888s1,1.073,1.193,4.365a7.547,7.547,0,0,1-2.463.6,9.142,9.142,0,0,1-1.346-5.073A4.419,4.419,0,0,1,324.113,110.888Z",
    transform: "translate(-314.172 -63.245)",
    fill: "#7f9ec9"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5370",
    "data-name": "Trazado 5370",
    d: "M307.767,112.488s.634-4.249-1.8-5.874l-1.991.253a8.564,8.564,0,0,0,1.2,5.986S307.158,112.628,307.767,112.488Z",
    transform: "translate(-279.078 -63.245)",
    fill: "#38368e"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5371",
    "data-name": "Trazado 5371",
    d: "M323.983,110.7a18.2,18.2,0,0,1,1.321,4.83,5.516,5.516,0,0,1-1.711.323,8.3,8.3,0,0,1-1.346-5.073A4.094,4.094,0,0,1,323.983,110.7Z",
    transform: "translate(-314.923 -63.245)",
    fill: "#38368e"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5372",
    "data-name": "Trazado 5372",
    d: "M309.605,109.189s-4.642-2.7-12.552-1.16l1.468-1.113A13.227,13.227,0,0,1,309.605,109.189Z",
    transform: "translate(-274.03 -63.245)",
    fill: "#131163"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5373",
    "data-name": "Trazado 5373",
    d: "M327.1,112.316a12.538,12.538,0,0,0-8.063-.931l1.789-1.324S323.732,109.616,327.1,112.316Z",
    transform: "translate(-313.499 -63.245)",
    fill: "#131163"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5374",
    "data-name": "Trazado 5374",
    d: "M304.474,109.189a2.749,2.749,0,0,0-2.4.872A2.187,2.187,0,0,0,304.474,109.189Z",
    transform: "translate(-273.92 -63.245)",
    fill: "#fff"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5375",
    "data-name": "Trazado 5375",
    d: "M323.4,112.853s-1.979-.385-2.663.518C320.737,113.371,321.795,114.1,323.4,112.853Z",
    transform: "translate(-311.509 -63.245)",
    fill: "#fff"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5376",
    "data-name": "Trazado 5376",
    d: "M307.054,109.649a18.183,18.183,0,0,1-9.385,4.419l-.149-2.1.528.889S303.6,112.524,307.054,109.649Z",
    transform: "translate(-271.946 -63.245)",
    fill: "#c6659c"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5377",
    "data-name": "Trazado 5377",
    d: "M324.373,113.232s-.641,2.305-5.341,3.347l.151-1.129.264.4S322.787,115.426,324.373,113.232Z",
    transform: "translate(-310.777 -63.245)",
    fill: "#c6659c"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5378",
    "data-name": "Trazado 5378",
    d: "M323.4,122.453a16.741,16.741,0,0,0-4.974,0c-3.221.379-6.843,1.263-8.821,0,0,0,2.628,2.631,4.9,3.031s5.748-1.6,5.748-1.6l1.515.027A4.131,4.131,0,0,0,323.4,122.453Z",
    transform: "translate(-300.377 -63.245)",
    fill: "#cb5f7d"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5379",
    "data-name": "Trazado 5379",
    d: "M314.243,123.907a2.414,2.414,0,0,0-1.452-.381c-.663.127-1.338,1.092-1.338,1.092A6.607,6.607,0,0,1,314.243,123.907Z",
    transform: "translate(-293.068 -63.245)",
    fill: "#9f4a8b"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5380",
    "data-name": "Trazado 5380",
    d: "M313.865,122.453c-.842-.821,3.516-8.583,5.6-8.871s4.042,8.7,4.042,8.7-2.9.407-5.71.783S313.865,122.453,313.865,122.453Z",
    transform: "translate(-304.636 -63.245)",
    fill: "#ffbcaf"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5381",
    "data-name": "Trazado 5381",
    d: "M319.592,98.015c1.18-.15,5.35,4.92,5.35,4.92s2.65,8.21,2.13,10.64-6.96,3.73-6.96,3.73l-.27-.43v-.01a12.639,12.639,0,0,0,.79-2.46c.51-2.52-.58-8.27-1.37-12.98a9.666,9.666,0,0,1-.29-1.87C318.942,98.795,319.052,98.075,319.592,98.015Z",
    transform: "translate(-313.479 -63.245)",
    opacity: 0.6,
    fill: "url(#linear-gradient-20)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5382",
    "data-name": "Trazado 5382",
    d: "M281.552,131.355c1.33-2.78.51-4.23,12.06-5.74,16.35-2.15,17.75,2.84,20.53,2.08a2.674,2.674,0,0,0,.33-.12c3.01-1.17,10.1-8.14,10.28-17.53.19-9.76-6.35-16.68-6.35-16.68,2.37-1.99,3.32-7.76.76-10.23s-6.92-1.89-17.62-.76-10.71.48-10.71.48c-3.4.87-5.35,4.06-5.9,5.08-.11.2-.16.32-.16.32l-1.33-1.23a17.416,17.416,0,0,0-2.94,10.89s-5.87-11.94-5.2-13.63a45.383,45.383,0,0,1,4.82-7.96l.01-.01s.95-9.09,3.79-9.09,14.97,2.74,14.97,2.74a17.225,17.225,0,0,1-1.14-6.72l.05.05c3.96,3.55,7.83,3.94,13.31,6.48a13.869,13.869,0,0,1,5.13,3.72l.37.44.39.47c.38.48.77.97,1.24,1.47a.33.33,0,0,0,.06.06l.03.03a15.68,15.68,0,0,0,1.59,1.49c3.6,2.93,11.52,4.89,12.47,7.99s-1.2,7.32-2.34,11.68a23.734,23.734,0,0,0-.61,8.21,16.126,16.126,0,0,0-2.52,11.97c1.11,6.37,3.54,7.41,3.54,7.41a10.908,10.908,0,0,1,.9,6.79c-3.5,13.92-17.98,22.21-17.98,22.21-12.88,4.8-21.35,2.71-21.35,2.71l-.01-.01c-9.37-6.11-12.58-26.33-12.72-27.27C279.462,129.4,281.2,132.1,281.552,131.355Zm5.78,12.89c2.27-.38,2.75-6.13,3.5-6.89s4.87-.44,4.87-.44,3.79,4.3,5.3,4.42,9.6-3.16,7.85-8.08-7.85-5.56-7.85-5.56a14.8,14.8,0,0,1-7.89,2.96c-4.74.31-6.45-.56-7.01-.81s-3.62,1.13-3.54,5.43C282.612,138.265,285.052,144.625,287.332,144.245Z",
    transform: "translate(-275.249 -63.245)",
    fill: "url(#linear-gradient-57)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5383",
    "data-name": "Trazado 5383",
    d: "M322.214,115.308s-4.082,5.07-3.693,6.976c.426,2.087,5.155,3.2,5.155,3.2s-3.792-1.308-4.568-3.2A25.186,25.186,0,0,1,322.214,115.308Z",
    transform: "translate(-309.543 -63.245)",
    fill: "#d2726c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5384",
    "data-name": "Trazado 5384",
    d: "M329.688,97.915a17.416,17.416,0,0,1,2.94-10.89,29.093,29.093,0,0,1-3.31-10.71l-.01.01a36.713,36.713,0,0,0-1.54,7.1l-3.28.86C323.818,85.975,329.688,97.915,329.688,97.915Z",
    transform: "translate(-324.435 -63.245)",
    opacity: 0.6,
    fill: "url(#linear-gradient-58)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5385",
    "data-name": "Trazado 5385",
    d: "M275.249,87.935c.55-1.02,2.5-4.21,5.9-5.08,0,0,0,.66,10.71-.48s15.06-1.7,17.62.76,1.61,8.24-.76,10.23c0,0,6.54,6.92,6.35,16.68-.18,9.39-7.27,16.36-10.28,17.53l.14,1.04s-.53,21.5-5.76,23.21-16.06.82-17.07,1.83c-.96.96.14,2.61.24,2.76l.01.01s8.47,2.09,21.35-2.71c0,0,14.48-8.29,17.98-22.21a10.908,10.908,0,0,0-.9-6.79s-2.43-1.04-3.54-7.41a16.126,16.126,0,0,1,2.52-11.97,23.734,23.734,0,0,1,.61-8.21c1.14-4.36,3.29-8.59,2.34-11.68a13.637,13.637,0,0,1-10.04-2.21s-1.06-1.47-5.75-2.23-23.54,1.14-23.54,1.14a16.2,16.2,0,0,1,5.87-2.61c3.76-.99,16.6.16,17.98.27-1.47-.26-16.03-2.76-17.69-2.26-1.76.52-8.06,3.41-8.06,3.41.57-2.89,6.21-9.85,6.21-9.85a88.477,88.477,0,0,1,13.17,1.23,17.036,17.036,0,0,1,7.7,3.54l-1.24-1.47-.39-.47-.37-.44-1.82-.31L295.6,69.5c-3.07-1.64-7-5.7-7.48-6.2l-.05-.05a17.225,17.225,0,0,0,1.14,6.72c-7.72-.95-10.33-.47-10.33-.47C275.369,74.465,275.249,87.935,275.249,87.935Z",
    transform: "translate(-265.566 -63.245)",
    opacity: 0.6,
    fill: "url(#linear-gradient-59)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5386",
    "data-name": "Trazado 5386",
    d: "M316.256,153.715a48.143,48.143,0,0,0-11.875-.835c-7.142.288-11.247.317-9.475,3.545C294.906,156.425,303.876,158.451,316.256,153.715Z",
    transform: "translate(-278.123 -63.245)",
    opacity: 0.5,
    fill: "url(#linear-gradient-60)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5387",
    "data-name": "Trazado 5387",
    d: "M315.041,69.5s-4.343-1.694-6.056-1.416a3.361,3.361,0,0,1,1.389-1.1c.711-.189,15,2.981,15,2.981S316.462,68.926,315.041,69.5Z",
    transform: "translate(-301.728 -63.245)",
    fill: "url(#linear-gradient-61)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5388",
    "data-name": "Trazado 5388",
    d: "M285.772,71.105s.341,4.727,1.85,6.44l17.69,2.26,5.193-.916a13.059,13.059,0,0,1-4.218-3.434C304.079,72.878,292.545,70.346,285.772,71.105Z",
    transform: "translate(-263.649 -63.245)",
    fill: "url(#linear-gradient-62)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5389",
    "data-name": "Trazado 5389",
    d: "M332.575,76.315a39.818,39.818,0,0,0-1.55,7.11l-3.28.86A23.57,23.57,0,0,1,332.575,76.315Z",
    transform: "translate(-327.692 -63.245)",
    fill: "url(#linear-gradient-63)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5390",
    "data-name": "Trazado 5390",
    d: "M268.726,116.579s1.243-5.968,4.293-8.921a7.167,7.167,0,0,1,6.523-2s-.948,11.068-1.942,13.768-2.511,3.411-2.511,3.411a8.521,8.521,0,0,0,2.416-5.529c.284-3.661.379-8.825-.426-9.44s-4.06,1.786-4.06,1.786a10.811,10.811,0,0,1,1.644,4.521c.616,3.262-1.658,5.63-2.511,5.583s.048-3.774-.1-4.848S270.021,114.068,268.726,116.579Z",
    transform: "translate(-215.64 -63.245)",
    opacity: 0.8,
    fill: "url(#linear-gradient-64)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5391",
    "data-name": "Trazado 5391",
    d: "M275.711,109.16a7.457,7.457,0,0,1,2.97,6.674c-.359,4.487-2.923,4.291-2.932,3.349s.488-3.366.228-4.738-2.474-.751-2.474-.751A32.924,32.924,0,0,1,275.711,109.16Z",
    transform: "translate(-219.583 -63.245)",
    opacity: 0.8,
    fill: "url(#linear-gradient-65)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5392",
    "data-name": "Trazado 5392",
    d: "M315.845,129.145s4.137,18.873,12.73,27.28C328.575,156.425,318.775,152.574,315.845,129.145Z",
    transform: "translate(-311.792 -63.245)",
    fill: "#34c7ff"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5393",
    "data-name": "Trazado 5393",
    d: "M328.058,66.984s-2.182,1.7-2.6,7.6S327.6,87.025,327.6,87.025a23.678,23.678,0,0,1-3.6-10.267C323.693,71.389,326.329,67.663,328.058,66.984Z",
    transform: "translate(-319.412 -63.245)",
    fill: "#34c7ff"
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5394",
    "data-name": "Trazado 5394",
    d: "M314.815,79.334a51.011,51.011,0,0,1-10.589,2.211c-5.54.489-6.678.6-6.678.6s2.226-2.16,6.968-2.811A48.063,48.063,0,0,1,314.815,79.334Z",
    transform: "translate(-177.731 -63.245)",
    fill: "url(#linear-gradient-66)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5395",
    "data-name": "Trazado 5395",
    d: "M327.093,129.558s-2.416,0-3.367,3.031a25.235,25.235,0,0,0-.967,4.5l-.856-3.323s1.116-4.208,2.277-5.155c.836-.682,2.275-1.375,2.96-1.208Z",
    transform: "translate(-214.411 -63.245)",
    fill: "url(#linear-gradient-67)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5396",
    "data-name": "Trazado 5396",
    d: "M321.085,126.526l-.408,3.6a12.851,12.851,0,0,1-4.892-.568l-.348-2.179A27.285,27.285,0,0,1,321.085,126.526Z",
    transform: "translate(-201.89 -63.245)",
    fill: "url(#linear-gradient-68)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5397",
    "data-name": "Trazado 5397",
    d: "M354.492,173.055s-17.226,12.582-19.463,16.91-3.14,17.9-6.164,23.776c0,0,2.066-9.608,3.516-17.142s1.1-7.641,1.908-9.488S347.961,176.336,354.492,173.055Z",
    transform: "translate(-248.725 -63.245)",
    fill: "#34c7ff"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5398",
    "data-name": "Trazado 5398",
    d: "M319.806,243.1s8.3,35.542,7.926,37.944-5.752,7.3-6,8.643c0,0,4.108,5.5,3.918,6.719s-7.2,8.925-7.01,11.307c.054.692,4.6,8.194,4.6,8.194s-5.139-7.374-5.392-8.55,6.3-11.026,6.489-12.027c.5-2.591-3.268-4.5-3.394-6.2s5.1-5.871,5.137-8.651S319.806,243.1,319.806,243.1Z",
    transform: "translate(-210.952 -63.245)",
    fill: "#34c7ff"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5399",
    "data-name": "Trazado 5399",
    d: "M351.537,327.825s-17.95,40.635-24.072,81.27C327.465,409.1,328.487,369.439,351.537,327.825Z",
    transform: "translate(-244.37 -63.245)",
    fill: "#34c7ff"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5400",
    "data-name": "Trazado 5400",
    d: "M206.2,164.9s4.644-.993,6.571-5.044.669-9.916.669-9.916a102.185,102.185,0,0,1-5.448,9.357C206.181,161.674,205.695,164.389,206.2,164.9Z",
    transform: "translate(14.777 -63.245)",
    fill: "#ffbcaf"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "DEVELOPER",
    transform: "matrix(0.999, -0.052, 0.052, 0.999, 141.458, 149.847)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "Copperplate"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -33.924,
    y: 0
  }, "DEVELOPER")))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2858",
    "data-name": "Grupo 2858",
    transform: "translate(71.003 126.29)"
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5401",
    "data-name": "Trazado 5401",
    d: "M534.048,143.71l-3.22,91.795a6.765,6.765,0,0,1-6.76,6.527H365.936a6.763,6.763,0,0,1-6.762-6.6l-2.213-92.869a6.764,6.764,0,0,1,6.807-6.925l163.564,1.074A6.765,6.765,0,0,1,534.048,143.71Z",
    transform: "translate(-356.709 -135.385)",
    fill: "#36d1f7",
    opacity: 0.6
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2854",
    "data-name": "Grupo 2854"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5402",
    "data-name": "Trazado 5402",
    d: "M365.936,242.282H524.068a6.989,6.989,0,0,0,7.01-6.768l3.22-91.8a7.015,7.015,0,0,0-6.963-7.259l-163.566-1.074a7.066,7.066,0,0,0-5.049,2.1,6.96,6.96,0,0,0-2.009,5.084l2.213,92.869A6.972,6.972,0,0,0,365.936,242.282Zm-2.215-106.4h.044l163.566,1.074A6.513,6.513,0,0,1,533.8,143.7l-3.22,91.795a6.49,6.49,0,0,1-6.51,6.286H365.936a6.554,6.554,0,0,1-6.512-6.359l-2.213-92.869a6.513,6.513,0,0,1,6.51-6.669Z",
    transform: "translate(-356.709 -135.385)",
    fill: "#744ca2"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5403",
    "data-name": "Trazado 5403",
    d: "M534.062,148.385H357.4l-.284-4.841a7.414,7.414,0,0,1,7.459-7.847l163.5,1.292a6.134,6.134,0,0,1,6.084,6.249Z",
    transform: "translate(-356.959 -135.385)",
    opacity: 0.6,
    fill: "url(#linear-gradient-69)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5404",
    "data-name": "Trazado 5404",
    d: "M420.157,155.791v53.124H366.081v-53.4Z",
    transform: "translate(-251.936 -135.385)",
    opacity: 0.3,
    fill: "url(#linear-gradient-70)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xE1ngulo_2316",
    "data-name": "Rect\xE1ngulo 2316",
    width: 23.523,
    height: 23.523,
    transform: "translate(38.363 23.971)",
    opacity: 0.3,
    fill: "url(#linear-gradient-70)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xE1ngulo_2317",
    "data-name": "Rect\xE1ngulo 2317",
    width: 23.523,
    height: 23.523,
    transform: "translate(10.609 23.971)",
    opacity: 0.3,
    fill: "url(#linear-gradient-70)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xE1ngulo_2318",
    "data-name": "Rect\xE1ngulo 2318",
    width: 23.523,
    height: 23.523,
    transform: "translate(66.58 23.971)",
    opacity: 0.3,
    fill: "url(#linear-gradient-70)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xE1ngulo_2319",
    "data-name": "Rect\xE1ngulo 2319",
    width: 60.153,
    height: 5.635,
    transform: "translate(10.609 61.208)",
    fill: "#d1d4fb",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xE1ngulo_2320",
    "data-name": "Rect\xE1ngulo 2320",
    width: 75.198,
    height: 1.744,
    transform: "translate(10.609 69.783)",
    fill: "#d1d4fb",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xE1ngulo_2321",
    "data-name": "Rect\xE1ngulo 2321",
    width: 14.386,
    height: 1.744,
    transform: "translate(70.713 50.493)",
    fill: "#d1d4fb",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xE1ngulo_2322",
    "data-name": "Rect\xE1ngulo 2322",
    width: 14.386,
    height: 1.744,
    transform: "translate(42.931 50.493)",
    fill: "#d1d4fb",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xE1ngulo_2323",
    "data-name": "Rect\xE1ngulo 2323",
    width: 14.386,
    height: 1.744,
    transform: "translate(15.177 50.493)",
    fill: "#d1d4fb",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xE1ngulo_2324",
    "data-name": "Rect\xE1ngulo 2324",
    width: 24.19,
    height: 1.744,
    transform: "translate(65.913 72.617)",
    fill: "#d1d4fb",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xE1ngulo_2325",
    "data-name": "Rect\xE1ngulo 2325",
    width: 75.198,
    height: 1.744,
    transform: "translate(10.609 75.418)",
    fill: "#d1d4fb",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xE1ngulo_2326",
    "data-name": "Rect\xE1ngulo 2326",
    width: 79.493,
    height: 1.744,
    transform: "translate(10.609 78.219)",
    fill: "#d1d4fb",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xE1ngulo_2327",
    "data-name": "Rect\xE1ngulo 2327",
    width: 79.493,
    height: 1.744,
    transform: "translate(10.609 81.019)",
    fill: "#d1d4fb",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xE1ngulo_2328",
    "data-name": "Rect\xE1ngulo 2328",
    width: 75.198,
    height: 1.744,
    transform: "translate(10.609 92.343)",
    fill: "#d1d4fb",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xE1ngulo_2329",
    "data-name": "Rect\xE1ngulo 2329",
    width: 79.493,
    height: 1.744,
    transform: "translate(10.609 95.144)",
    fill: "#d1d4fb",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xE1ngulo_2330",
    "data-name": "Rect\xE1ngulo 2330",
    width: 79.493,
    height: 1.744,
    transform: "translate(10.609 97.945)",
    fill: "#d1d4fb",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xE1ngulo_2331",
    "data-name": "Rect\xE1ngulo 2331",
    width: 76.295,
    height: 1.744,
    transform: "translate(13.807 83.82)",
    fill: "#d1d4fb",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xE1ngulo_2332",
    "data-name": "Rect\xE1ngulo 2332",
    width: 75.198,
    height: 1.744,
    transform: "translate(10.609 86.621)",
    fill: "#d1d4fb",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xE1ngulo_2333",
    "data-name": "Rect\xE1ngulo 2333",
    width: 64.406,
    height: 1.744,
    transform: "translate(25.697 89.422)",
    fill: "#d1d4fb",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2855",
    "data-name": "Grupo 2855",
    transform: "translate(137.687 32.11)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5405",
    "data-name": "Trazado 5405",
    d: "M381.231,198.262a15.383,15.383,0,1,0-15.383-15.384A15.4,15.4,0,0,0,381.231,198.262Zm0-29.767a14.383,14.383,0,1,1-14.383,14.383A14.4,14.4,0,0,1,381.231,168.495Z",
    transform: "translate(-365.848 -167.495)",
    fill: "#e0ffff"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1022",
    "data-name": "Elipse 1022",
    cx: 8.36,
    cy: 8.36,
    r: 8.36,
    transform: "translate(144.71 39.133)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2856",
    "data-name": "Grupo 2856",
    transform: "translate(98.761 4.743)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5406",
    "data-name": "Trazado 5406",
    d: "M420.157,170.9a15.384,15.384,0,1,0-15.383-15.384A15.4,15.4,0,0,0,420.157,170.9Zm0-29.768a14.384,14.384,0,1,1-14.383,14.384A14.4,14.4,0,0,1,420.157,141.128Z",
    transform: "translate(-404.774 -140.128)",
    fill: "#e0ffff"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_1023",
    "data-name": "Elipse 1023",
    cx: 7.867,
    cy: 7.867,
    rx: 7.867,
    ry: 7.867,
    transform: "matrix(-0.155, -0.988, 0.988, -0.155, 107.596, 29.121)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2857",
    "data-name": "Grupo 2857",
    transform: "translate(163.555 4.087)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5407",
    "data-name": "Trazado 5407",
    d: "M370.591,141.176l-1.124-1.7-6.078,5.328.932,1.3Z",
    transform: "translate(-363.233 -139.472)",
    fill: "#fff"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5408",
    "data-name": "Trazado 5408",
    d: "M363.545,141.176l1.124-1.7,6.078,5.328-.932,1.3Z",
    transform: "translate(-363.545 -139.472)",
    fill: "#fff"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xE1ngulo_2334",
    "data-name": "Rect\xE1ngulo 2334",
    width: 54.442,
    height: 2.729,
    transform: "translate(4.713 5.244)",
    fill: "#fff"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2859",
    "data-name": "Grupo 2859",
    transform: "translate(386.169 91.365)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5409",
    "data-name": "Trazado 5409",
    d: "M217.292,101.217v23.623l-28.256.241-.381-24.622Z",
    transform: "translate(-186.811 -100.46)",
    fill: "url(#linear-gradient-74)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5410",
    "data-name": "Trazado 5410",
    d: "M218.755,100.46l-1.844,3.1.922,21.5,1.3.022Z",
    transform: "translate(-216.911 -100.46)",
    fill: "url(#linear-gradient-75)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5411",
    "data-name": "Trazado 5411",
    d: "M210.42,109.191l-2.61-3.788L193.7,117.246l2.164,2.887Z",
    transform: "translate(-184.984 -100.46)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5412",
    "data-name": "Trazado 5412",
    d: "M194.063,109.191l2.61-3.788,14.11,11.842-2.164,2.887Z",
    transform: "translate(-185.709 -100.46)",
    fill: "#fff"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2862",
    "data-name": "Grupo 2862",
    transform: "translate(340.386 274.787)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5413",
    "data-name": "Trazado 5413",
    d: "M158.255,379.276h96.689a7.92,7.92,0,0,0,7.917-7.739l1.8-79.306a7.919,7.919,0,0,0-7.917-8.1H156.08a7.918,7.918,0,0,0-7.915,8.136l2.175,79.306A7.918,7.918,0,0,0,158.255,379.276Z",
    transform: "translate(-147.911 -283.882)",
    opacity: 0.81,
    fill: "url(#linear-gradient-76)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2860",
    "data-name": "Grupo 2860"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5414",
    "data-name": "Trazado 5414",
    d: "M158.256,379.525h96.689a8.217,8.217,0,0,0,8.167-7.982l1.8-79.306a8.168,8.168,0,0,0-8.167-8.355H156.081a8.17,8.17,0,0,0-8.166,8.392l2.176,79.307A8.125,8.125,0,0,0,158.256,379.525Zm98.494-95.143a7.667,7.667,0,0,1,7.667,7.844l-1.8,79.3a7.713,7.713,0,0,1-7.667,7.494H158.256a7.628,7.628,0,0,1-7.665-7.458l-2.176-79.306a7.67,7.67,0,0,1,7.666-7.879Z",
    transform: "translate(-147.912 -283.882)",
    fill: "#473da2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2861",
    "data-name": "Grupo 2861",
    transform: "translate(39.842 16.471)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xE1ngulo_2335",
    "data-name": "Rect\xE1ngulo 2335",
    width: 50.85,
    height: 2.177,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xE1ngulo_2336",
    "data-name": "Rect\xE1ngulo 2336",
    width: 25.425,
    height: 2.177,
    transform: "translate(25.425 5.296)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xE1ngulo_2337",
    "data-name": "Rect\xE1ngulo 2337",
    width: 25.425,
    height: 2.177,
    transform: "translate(25.425 9.717)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xE1ngulo_2338",
    "data-name": "Rect\xE1ngulo 2338",
    width: 20.228,
    height: 2.177,
    transform: "translate(2.345 9.717)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xE1ngulo_2339",
    "data-name": "Rect\xE1ngulo 2339",
    width: 40.989,
    height: 2.177,
    transform: "translate(9.86 14.138)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xE1ngulo_2340",
    "data-name": "Rect\xE1ngulo 2340",
    width: 14.589,
    height: 2.177,
    transform: "translate(36.26 18.559)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xE1ngulo_2341",
    "data-name": "Rect\xE1ngulo 2341",
    width: 25.232,
    height: 2.177,
    transform: "translate(8.029 31.822)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xE1ngulo_2342",
    "data-name": "Rect\xE1ngulo 2342",
    width: 45.726,
    height: 2.177,
    transform: "translate(5.124 22.98)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xE1ngulo_2343",
    "data-name": "Rect\xE1ngulo 2343",
    width: 35.179,
    height: 2.177,
    transform: "translate(15.671 27.401)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xE1ngulo_2344",
    "data-name": "Rect\xE1ngulo 2344",
    width: 16.547,
    height: 2.177,
    transform: "translate(34.302 31.822)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xE1ngulo_2345",
    "data-name": "Rect\xE1ngulo 2345",
    width: 25.425,
    height: 2.177,
    transform: "translate(25.425 36.243)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xE1ngulo_2346",
    "data-name": "Rect\xE1ngulo 2346",
    width: 7.295,
    height: 2.177,
    transform: "translate(43.555 40.664)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xE1ngulo_2347",
    "data-name": "Rect\xE1ngulo 2347",
    width: 26.463,
    height: 2.177,
    transform: "translate(14.092 40.664)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xE1ngulo_2348",
    "data-name": "Rect\xE1ngulo 2348",
    width: 25.232,
    height: 2.177,
    transform: "translate(8.029 44.954)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xE1ngulo_2349",
    "data-name": "Rect\xE1ngulo 2349",
    width: 16.547,
    height: 2.177,
    transform: "translate(34.302 44.954)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xE1ngulo_2350",
    "data-name": "Rect\xE1ngulo 2350",
    width: 25.425,
    height: 2.177,
    transform: "translate(25.425 49.376)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xE1ngulo_2351",
    "data-name": "Rect\xE1ngulo 2351",
    width: 7.295,
    height: 2.177,
    transform: "translate(43.555 53.797)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xE1ngulo_2352",
    "data-name": "Rect\xE1ngulo 2352",
    width: 26.463,
    height: 2.177,
    transform: "translate(14.092 53.797)",
    fill: "#fff"
  })))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5415",
    "data-name": "Trazado 5415",
    d: "M505.086,117.934a4.469,4.469,0,1,0,4.469-4.468A4.469,4.469,0,0,0,505.086,117.934Z",
    transform: "translate(-413.804 -9.095)",
    fill: "url(#linear-gradient-77)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5416",
    "data-name": "Trazado 5416",
    d: "M84,221.571a5.562,5.562,0,1,0,5.562-5.561A5.562,5.562,0,0,0,84,221.571Z",
    transform: "translate(426.183 -9.095)",
    fill: "url(#linear-gradient-77)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1024",
    "data-name": "Elipse 1024",
    cx: 4.469,
    cy: 4.469,
    r: 4.469,
    transform: "translate(78.157 104.371)",
    fill: "url(#linear-gradient-79)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1025",
    "data-name": "Elipse 1025",
    cx: 3.16,
    cy: 3.16,
    r: 3.16,
    transform: "translate(367.637 136.406)",
    fill: "url(#linear-gradient-79)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1026",
    "data-name": "Elipse 1026",
    cx: 3.16,
    cy: 3.16,
    r: 3.16,
    transform: "translate(155.98 275.844)",
    fill: "url(#linear-gradient-81)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1027",
    "data-name": "Elipse 1027",
    cx: 2.825,
    cy: 2.825,
    r: 2.825,
    transform: "translate(484.837 307.683)",
    fill: "url(#linear-gradient-81)"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2867",
    "data-name": "Grupo 2867",
    transform: "translate(430.992 235.858)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5417",
    "data-name": "Trazado 5417",
    d: "M116.9,291.866h48.8a7.283,7.283,0,0,0,7.279-7.037l1.084-32.1a7.283,7.283,0,0,0-7.28-7.529H115.916a7.283,7.283,0,0,0-7.28,7.505l.981,32.1A7.283,7.283,0,0,0,116.9,291.866Z",
    transform: "translate(-108.383 -244.953)",
    opacity: 0.73,
    fill: "url(#linear-gradient-83)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2863",
    "data-name": "Grupo 2863"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5418",
    "data-name": "Trazado 5418",
    d: "M116.9,292.116h48.8a7.5,7.5,0,0,0,7.529-7.279l1.084-32.1a7.535,7.535,0,0,0-7.53-7.788H115.916a7.532,7.532,0,0,0-7.53,7.764l.981,32.1A7.5,7.5,0,0,0,116.9,292.116Zm49.882-46.663a7.034,7.034,0,0,1,7.03,7.271l-1.084,32.1a7.006,7.006,0,0,1-7.029,6.8H116.9a7,7,0,0,1-7.03-6.818l-.981-32.1a7.033,7.033,0,0,1,7.03-7.248Z",
    transform: "translate(-108.383 -244.953)",
    fill: "#953da2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2864",
    "data-name": "Grupo 2864",
    transform: "translate(44.082 11.782)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5419",
    "data-name": "Trazado 5419",
    d: "M118.2,256.735l12.031,13.946-12.253,10.4v-5.368l7.088-6.136-6.583-7.443Z",
    transform: "translate(-117.979 -256.735)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2865",
    "data-name": "Grupo 2865",
    transform: "translate(11.122 12.408)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5420",
    "data-name": "Trazado 5420",
    d: "M162.17,257.361l-12.032,13.946,12.253,10.4V276.34L155.3,270.2l7.888-8.347Z",
    transform: "translate(-150.139 -257.361)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2866",
    "data-name": "Grupo 2866",
    transform: "translate(26.272 13.034)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5421",
    "data-name": "Trazado 5421",
    d: "M148.042,281.082l-10.484-23.095h-4.926L144.5,281.082Z",
    transform: "translate(-132.631 -257.987)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2869",
    "data-name": "Grupo 2869",
    transform: "translate(100.589 290.197)"
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5422",
    "data-name": "Trazado 5422",
    d: "M432.951,357.916H494a9.111,9.111,0,0,0,9.106-8.8l1.356-40.151a9.112,9.112,0,0,0-9.107-9.419H431.724a9.111,9.111,0,0,0-9.107,9.39l1.227,40.151A9.112,9.112,0,0,0,432.951,357.916Z",
    transform: "translate(-422.362 -299.292)",
    opacity: 0.73,
    fill: "url(#linear-gradient-83)"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2868",
    "data-name": "Grupo 2868"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5423",
    "data-name": "Trazado 5423",
    d: "M432.953,358.166H494a9.324,9.324,0,0,0,9.356-9.045l1.355-40.151a9.363,9.363,0,0,0-9.355-9.678h-63.63a9.363,9.363,0,0,0-9.358,9.647l1.228,40.152A9.318,9.318,0,0,0,432.953,358.166Zm62.4-58.374a8.86,8.86,0,0,1,8.855,9.16L502.856,349.1A8.825,8.825,0,0,1,494,357.666H432.953a8.82,8.82,0,0,1-8.857-8.591l-1.228-40.151a8.863,8.863,0,0,1,8.858-9.132Z",
    transform: "translate(-422.364 -299.292)",
    fill: "#953da2"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xE1ngulo_2353",
    "data-name": "Rect\xE1ngulo 2353",
    width: 55.911,
    height: 33.206,
    transform: "translate(13.955 6.714)",
    fill: "#d1d4fb",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5424",
    "data-name": "Trazado 5424",
    d: "M472.143,314.246v16.727l-14.287-9.129Z",
    transform: "translate(-425.283 -299.292)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xE1ngulo_2354",
    "data-name": "Rect\xE1ngulo 2354",
    width: 55.911,
    height: 3.036,
    transform: "translate(13.955 46.04)",
    fill: "#d1d4fb",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xE1ngulo_2355",
    "data-name": "Rect\xE1ngulo 2355",
    width: 14.474,
    height: 3.036,
    transform: "translate(55.391 46.04)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2872",
    "data-name": "Grupo 2872",
    transform: "translate(199.429 271.091)"
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2870",
    "data-name": "Grupo 2870",
    transform: "translate(0 2.772)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5425",
    "data-name": "Trazado 5425",
    d: "M388.049,295.51l2.917,8.349C389.356,299.245,387.037,296.25,388.049,295.51Zm2.917,8.349,2.924,8.346C393.154,311.985,392.584,308.47,390.966,303.859Zm-2.917-8.349,2.917,8.349C389.356,299.245,387.037,296.25,388.049,295.51Zm2.917,8.349,2.924,8.346C393.154,311.985,392.584,308.47,390.966,303.859Zm-8.424,7.232-2.834,1.607-3.06-8.352,3.279-.549c-.059-.31-.117-.62-.158-.926a21.556,21.556,0,0,1-.277-4.163l-3.429-2.152,1.563-7.357,3.286,3.143a9.51,9.51,0,0,1,1.68-2.449,6.609,6.609,0,0,1,.57-.555l-2.01-4.64,5.347-1.74h0l1.285,4.676a8.9,8.9,0,0,1,3.621.847l.589-4.421,5.888,4.457-1.36,3.918a22.3,22.3,0,0,1,2.873,4.182l2.837-1.6,3.059,8.352-3.278.549a22.736,22.736,0,0,1,.434,5.089l3.429,2.152-1.562,7.357-3.287-3.143a9.238,9.238,0,0,1-2.252,3l2.012,4.648-5.263,2.052-.815-2.964-.553-2.024a8.933,8.933,0,0,1-3.629-.845l-.582,4.419-5.888-4.457,1.36-3.918a21.835,21.835,0,0,1-2.317-3.2C382.9,311.754,382.725,311.426,382.542,311.091Zm8.424-7.232c1.618,4.611,0,9.368,2.924,8.346s4-5.6,2.384-10.2-5.3-7.515-8.225-6.493S389.356,299.245,390.966,303.859Zm-2.917-8.349,2.917,8.349C389.356,299.245,387.037,296.25,388.049,295.51Zm2.917,8.349,2.924,8.346C393.154,311.985,392.584,308.47,390.966,303.859Z",
    transform: "translate(-376.063 -282.958)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-85)"
  }))), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5426",
    "data-name": "Trazado 5426",
    d: "M373.3,312.7l-3.06-8.352,3.121-1.475.505-.237-.328-4.6-3.464-1.691,1.144-7.144,7.545-2.457-1.39,3.315-2.629-5.359,5.347-1.74,2.2-.717,5.272-2.055.985,3.6,4.586-2.18,5.888,4.457-1.786,4.818,5.505,15.265,2.72,9.914-5.228.572,1.7,3.929-5.272,2.055-7.544,2.457,1.211-2.423.762-1.451-2.788.91-4.764,1.55-5.888-4.457,3.642-4.289-4.6-2.832ZM389.865,302c-1.618-4.612-5.3-7.515-8.225-6.493l2.917,8.349,2.924,8.346C390.412,311.173,391.481,306.607,389.865,302Z",
    transform: "translate(-369.654 -280.186)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-86)"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2871",
    "data-name": "Grupo 2871",
    transform: "translate(7.545)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5427",
    "data-name": "Trazado 5427",
    d: "M372.158,310.236l-3.058-8.353,3.281-.548a22.849,22.849,0,0,1-.437-5.083l-3.43-2.152,1.563-7.358,3.288,3.142a9.175,9.175,0,0,1,2.25-3L373.6,282.24l5.269-2.054,1.365,4.987a8.943,8.943,0,0,1,3.623.845l.584-4.416,5.888,4.454-1.356,3.917a22.611,22.611,0,0,1,2.873,4.188l2.838-1.6,3.058,8.352-3.281.549a22.849,22.849,0,0,1,.437,5.083l3.43,2.151-1.564,7.358-3.288-3.141a9.18,9.18,0,0,1-2.249,3l2.012,4.642-5.269,2.054-1.365-4.986a8.959,8.959,0,0,1-3.623-.845l-.584,4.415-5.888-4.453,1.355-3.918a22.666,22.666,0,0,1-2.873-4.187Zm14.188-.493c2.929-1.026,3.995-5.594,2.38-10.2s-5.3-7.514-8.227-6.488-3.995,5.594-2.38,10.2S383.417,310.77,386.346,309.743Z",
    transform: "translate(-368.514 -280.186)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-87)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5428",
    "data-name": "Trazado 5428",
    d: "M394.9,296.556l7.545-2.456,3.43,2.151-7.545,2.456Z",
    transform: "translate(-394.901 -280.186)",
    fill: "#601734",
    fillRule: "evenodd",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5429",
    "data-name": "Trazado 5429",
    d: "M388.977,319.2l7.55-2.459,1.356-3.917-7.545,2.458Z",
    transform: "translate(-380.983 -280.186)",
    fill: "#b3d9ff",
    fillRule: "evenodd",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5430",
    "data-name": "Trazado 5430",
    d: "M400.787,286.883l-4.138,1.2-1.4-1.337-2.747.894L391.23,284.7l7.545-2.458Z",
    transform: "translate(-386.141 -280.186)",
    fill: "#601734",
    fillRule: "evenodd",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5431",
    "data-name": "Trazado 5431",
    d: "M384.19,317.623l-3.953,1.645.33-2.49A7.1,7.1,0,0,0,384.19,317.623Z",
    transform: "translate(-358.551 -280.186)",
    fill: "#601734",
    fillRule: "evenodd",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5432",
    "data-name": "Trazado 5432",
    d: "M389.213,295l-6.654,3.519a10.348,10.348,0,0,0-1.712-1.812S382.582,289.367,389.213,295Z",
    transform: "translate(-364.184 -280.186)",
    fill: "#601734",
    fillRule: "evenodd",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5433",
    "data-name": "Trazado 5433",
    d: "M230.64,46.057l-6.415,12.85,4.286,1.949,6-11.8Z",
    transform: "translate(146.572 -9.095)",
    fill: "#ff1d9c"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5434",
    "data-name": "Trazado 5434",
    d: "M91.912,345.4l-5.937,6.515-2.331-2.689,5.6-6.17Z",
    transform: "translate(429.75 -9.095)",
    fill: "#6877ff"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5435",
    "data-name": "Trazado 5435",
    d: "M377.043,124.463l5.981,3.629,2.4-4.544-6.538-3.818Z",
    transform: "translate(-157.158 -9.095)",
    fill: "#4f31e0"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5436",
    "data-name": "Trazado 5436",
    d: "M403.9,354.179l8.57,6.085,2.4-4.544-8.32-4.859Z",
    transform: "translate(-213.455 -9.095)",
    fill: "#4f31e0"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2873",
    "data-name": "Grupo 2873",
    transform: "translate(159.14 50.639)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5437",
    "data-name": "Trazado 5437",
    d: "M444.717,93.392l1.448-33.658h-44.07L403.907,93.3Z",
    transform: "translate(-402.095 -59.734)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-88)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5438",
    "data-name": "Trazado 5438",
    d: "M402.223,59.734l1.319,1.985-1.319,31.673h-1.448Z",
    transform: "translate(-358.153 -59.734)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-89)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5439",
    "data-name": "Trazado 5439",
    d: "M409.812,66.454l6.916-.741-.947,23.064-5.968-.586V85.8l3.458.082.395-17.785-3.853.11Z",
    transform: "translate(-380.375 -59.734)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5440",
    "data-name": "Trazado 5440",
    d: "M437.807,66.454l-6.916-.741.947,23.064,5.968-.586V85.8l-3.458.082L433.954,68.1l3.853.11Z",
    transform: "translate(-422.532 -59.734)",
    fill: "#fff"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2874",
    "data-name": "Grupo 2874",
    transform: "translate(503.76 135.035)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5441",
    "data-name": "Trazado 5441",
    d: "M71.589,167.075,70.6,144.13h30.044L99.41,167.01Z",
    transform: "translate(-69.702 -144.13)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-90)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5442",
    "data-name": "Trazado 5442",
    d: "M100.558,144.13l-.9,1.353.9,21.592h.987Z",
    transform: "translate(-99.658 -144.13)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-91)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5443",
    "data-name": "Trazado 5443",
    d: "M93.786,148.746a20.18,20.18,0,0,0-3.875.141c-.581.268.151,5.636.151,5.636l-1.313,1.205,1.227,1.19s-.065,5.441.71,5.893,3.423,0,3.423,0v-1.356a7.888,7.888,0,0,1-2.519-.155c-.355-.291-.323-5.044-.323-5.044l-.581-.635.581-.689s-.107-3.389-.043-4.318c.043-.619,2.562-.652,2.562-.652Z",
    transform: "translate(-81.313 -144.13)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5444",
    "data-name": "Trazado 5444",
    d: "M76.812,148.746a20.18,20.18,0,0,1,3.875.141c.581.268-.151,5.636-.151,5.636l1.313,1.205-1.227,1.19s.065,5.441-.71,5.893-3.423,0-3.423,0v-1.356a7.888,7.888,0,0,0,2.519-.155c.355-.291.323-5.044.323-5.044l.581-.635-.581-.689s.107-3.389.043-4.318c-.043-.619-2.562-.652-2.562-.652Z",
    transform: "translate(-56.793 -144.13)",
    fill: "#fff"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2884",
    "data-name": "Grupo 2884",
    transform: "translate(141.578 59.21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2875",
    "data-name": "Grupo 2875",
    transform: "translate(98.833 8.852)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5445",
    "data-name": "Trazado 5445",
    d: "M357.531,96.425l7.363-19.268L345.8,81.145Zm6.57-18.591-6.718,17.578-10.7-13.94Z",
    transform: "translate(-345.801 -77.157)",
    fill: "#744ca2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2876",
    "data-name": "Grupo 2876",
    transform: "translate(51.328 292.193)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xE1ngulo_2356",
    "data-name": "Rect\xE1ngulo 2356",
    width: 10.938,
    height: 0.499,
    transform: "matrix(-0.591, -0.807, 0.807, -0.591, 6.467, 9.117)",
    fill: "#744ca2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2877",
    "data-name": "Grupo 2877",
    transform: "translate(118.116 210.992)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5446",
    "data-name": "Trazado 5446",
    d: "M338.666,288.254l6.945-8.645-.391-.312-6.945,8.645Z",
    transform: "translate(-338.275 -279.297)",
    fill: "#744ca2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2878",
    "data-name": "Grupo 2878",
    transform: "translate(332.543 270.207)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5447",
    "data-name": "Trazado 5447",
    d: "M117.319,348.975l13.866-10.059-.294-.4L117.025,348.57Z",
    transform: "translate(-117.025 -338.512)",
    fill: "#744ca2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2879",
    "data-name": "Grupo 2879",
    transform: "translate(334.234 268.474)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xE1ngulo_2357",
    "data-name": "Rect\xE1ngulo 2357",
    width: 17.13,
    height: 0.5,
    transform: "matrix(-0.606, -0.795, 0.795, -0.606, 10.38, 13.929)",
    fill: "#744ca2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2880",
    "data-name": "Grupo 2880",
    transform: "translate(354.978 128.003)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xE1ngulo_2358",
    "data-name": "Rect\xE1ngulo 2358",
    width: 0.5,
    height: 10.139,
    transform: "translate(0.232 5.158) rotate(-117.719)",
    fill: "#744ca2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2881",
    "data-name": "Grupo 2881",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5448",
    "data-name": "Trazado 5448",
    d: "M463.352,80.465l.375-.33-10.371-11.83-.375.33Z",
    transform: "translate(-452.981 -68.305)",
    fill: "#744ca2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2882",
    "data-name": "Grupo 2882",
    transform: "translate(207.198 40.773)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xE1ngulo_2359",
    "data-name": "Rect\xE1ngulo 2359",
    width: 0.5,
    height: 10.406,
    transform: "translate(0.447 9.539) rotate(-153.551)",
    fill: "#744ca2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2883",
    "data-name": "Grupo 2883",
    transform: "translate(273.403 197.595)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xE1ngulo_2360",
    "data-name": "Rect\xE1ngulo 2360",
    width: 15.543,
    height: 0.499,
    transform: "matrix(-0.767, -0.642, 0.642, -0.767, 11.922, 10.356)",
    fill: "#744ca2"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactImg);
export default __webpack_public_path__ + "static/media/contact-img.7b06aa999e1eff18ba5c19c3d2646d09.svg";
export { ForwardRef as ReactComponent };